import { createContext, useContext, type ReactNode } from "react";

/**
 * Screens whose names run long (agencies, payees, locations) let a dropdown's open list grow wider than its
 * field, so each name sits on one line. Everywhere else the list keeps the field's width, as before.
 */
const ComboboxFitContext = createContext(false);

export function ComboboxFitProvider({ children }: { children: ReactNode }) {
  return <ComboboxFitContext.Provider value>{children}</ComboboxFitContext.Provider>;
}

export const useComboboxFit = () => useContext(ComboboxFitContext);
